import React, { useEffect, useState } from 'react';
import { noop } from '../../../utils/noop.js';
import { Field } from '../../Field/Field.js';
import { Input } from '../../Input/Input.js';
/**
 *
 * @deprecated This component is deprecated and will be removed in a future version. Please use the `DateInput` component instead.
 */
export const DateInput2 = ({ value = '', placeHolder, inputProps, handleOnSubmit = noop, errors: propsError, disabled, ...fieldProps }) => {
    const [inputValue, setInputValue] = useState('');
    const handleInputChange = (e) => {
        setError('');
        setInputValue(e.target.value);
    };
    const [error, setError] = useState();
    const [previousErrorState, setPreviousErrorState] = useState();
    useEffect(() => {
        setInputValue(value);
    }, [value]);
    useEffect(() => {
        setError(propsError?.error);
        if (propsError?.error && value) {
            setPreviousErrorState({ value: value, error: propsError?.error });
        }
    }, [propsError]);
    function handleKeyDown(e) {
        const trimInputValue = inputValue.trim();
        const trimValue = value.trim();
        const previousErrorValue = previousErrorState?.value.trim() ?? '';
        const previousError = previousErrorState?.error ?? '';
        if (e.key === 'Enter' && trimInputValue && trimInputValue !== trimValue && previousErrorValue !== trimInputValue) {
            handleOnSubmit(inputValue);
        }
        else if (e.key === 'Enter' && trimInputValue && previousErrorValue === trimInputValue) {
            setError(previousError);
        }
    }
    function handleBlur() {
        const trimInputValue = inputValue.trim();
        const trimValue = value.trim();
        const previousErrorValue = previousErrorState?.value.trim() ?? '';
        const previousError = previousErrorState?.error ?? '';
        if (trimInputValue !== trimValue && trimInputValue && previousErrorValue !== trimInputValue) {
            handleOnSubmit(inputValue);
        }
        else if (trimInputValue && previousErrorValue === trimInputValue) {
            setError(previousError);
        }
    }
    return (React.createElement(Field, { ...fieldProps, disabled: disabled, control: React.createElement(Input, { ...inputProps, appearance: error ? 'error' : undefined, addClassName: error && 'twds-mb-1', value: inputValue, disabled: disabled, onKeyDown: handleKeyDown, onBlur: handleBlur, onChange: handleInputChange, placeholder: placeHolder }), error: error }));
};
//# sourceMappingURL=date_input.js.map